import { isMobile } from "react-device-detect";
import styled, { css } from "styled-components";

export const Container = styled.article`
   background-color: ${({ theme, $variant }) => theme.card[$variant].default.background};
   border: ${({ theme, $variant }) => theme.card[$variant].default.border};
   height: 100%;
   width: 100%;

   :hover {
      ${({ $isClickeable, $isSelected }) => !isMobile && $isClickeable && !$isSelected && css`
         background-color: ${({ theme, $variant }) => theme.card[$variant].hover.background};
         border: ${({ theme, $variant }) => theme.card[$variant].hover.border};
      `}
   }

   ${({ $isSelected }) => $isSelected && css`
   background-color: ${({ theme, $variant }) => theme.card[$variant].focus.background};
         border: ${({ theme, $variant }) => theme.card[$variant].focus.border};
   `}

   transition: all 200ms;
   border-radius: 12px;

   margin: ${({ margin }) => margin};
   padding: ${({ padding }) => padding};

   cursor: ${({ $isClickeable }) => $isClickeable ? 'pointer' : 'unset'};

   ${({ props }) => props}
`